var Base = require('_js/base'),
  ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

// The different types of list we can search in.
var SEARCH_TYPES = ['Course', 'Article', 'Product'],
  SEARCH = {
    COURSE: 0,
    ARTICLE: 1,
    PRODUCT: 2
  },
  // We can sort the list by these types.
  SORT_TYPES = ['Date', 'Relevance'],
  SORT = {
    DATE: 0,
    RELEVANCE: 1
  },
  // The maximum amount of items on one page (/result).
  TAKE = 20;

function SearchComponent(params) {
  this.api = params.api;
  this.init(params.search);
}

SearchComponent.prototype.init = function(dataSearch) {
  this.searchInput = $('.search-input');

  // ======================================= \\
  // ===== Initialize the observables. ===== \\
  // The type of component to use based on the filter;
  this.resultBlock = ko.observable('product-block');
  // The amount of items per result type.
  this.articleResults = ko.observable(0);
  this.courseResults = ko.observable(0);
  this.productResults = ko.observable(0);
  // The total amount of results for the current tab.
  this.tabTotalResults = ko.observable(0);
  // The total amount of results for all tabs.
  this.totalResults = ko.computed(function() {
    return this.articleResults() + this.courseResults() + this.productResults();
  }, this);
  // The result (array of items).
  this.results = ko.observableArray();
  // Filter and sort.
  this.currentFilter = ko.observable(SEARCH.COURSE);
  this.currentSort = ko.observable(SORT.DATE);
  // How many items we should skip
  this.skip = ko.observable(0);
  // The value of the search input field.
  this.searchValue = ko.observable(dataSearch);
  // The amount of pages we have of results.
  this.pages = ko.computed(function() {
    var pages = this.tabTotalResults() / TAKE;
    if (pages < 1) {
      return 1;
    } else {
      return Math.ceil(pages);
    }
  }, this);
  // The current page.
  this.currentPage = ko.computed(function() {
    return Math.floor(this.skip() / TAKE + 1);
  }, this);

  // If we should show the results.
  this.showResults = ko.observable(false);
  // If what the user searched for has no results.
  this.hasNoResults = ko.observable(false);
  // If we're currently loading data from the API.
  this.isLoading = ko.observable(true);

  // ======================================= \\

  this.searchInput = $('.search-input');
  // Need to listen for <enter> in the search input field.
  this.searchInput.on(
    'keypress',
    function(e) {
      // If the user presses <enter> handle it in the same way as a submit/search click.
      if (e.which == 13 || e.keyCode == 13) {
        // Have to use a timeout or knockout won't be able to update searchValue.
        window.setTimeout(
          function() {
            this.handleSearchInput();
          }.bind(this),
          10
        );
      }
    }.bind(this)
  );

  var queryString = window.location.hash;

  // If the hash is defined do a search.
  if (queryString !== undefined && queryString.length > 0) {
    this.getParamsFromHash(queryString);
  }
  // If the hash is not defined, search with what we get from the data attribute (if set).
  else if (dataSearch !== undefined && dataSearch.length > 0) {
    this.search();
  }
};

SearchComponent.prototype.changePage = function(newPage) {
  this.skip(newPage * TAKE);
  this.search();
};

SearchComponent.prototype.search = function() {
  var params = this.constructSearchParams();
  // We need something to search for in order to do the API call.
  if (params.q === undefined || params.q.length <= 0) {
    return;
  }

  var url =
    this.api +
    '?type=' +
    encodeURIComponent(params.type) +
    '&q=' +
    encodeURIComponent(params.q) +
    '&sort=' +
    encodeURIComponent(params.sort) +
    '&skip=' +
    encodeURIComponent(params.skip) +
    '&take=' +
    encodeURIComponent(params.take);

  this.createHash(params);

  APIHelper.get(
    url,
    function(response) {
      this.showResults(true);
      this.isLoading(false);
      this.articleResults(response.TotalArticleResults);
      this.courseResults(response.TotalCourseResults);
      this.productResults(response.TotalProductResults);

      if (this.currentFilter() === SEARCH.COURSE) {
        this.resultBlock('media-tile');
        this.results(response.CourseResults);
        this.tabTotalResults(response.TotalCourseResults);
      } else if (this.currentFilter() === SEARCH.ARTICLE) {
        this.resultBlock('article-block');
        this.results(response.ArticleResults);
        this.tabTotalResults(response.TotalArticleResults);
      } else if (this.currentFilter() === SEARCH.PRODUCT) {
        this.resultBlock('product-block');
        this.results(response.ProductResults);
        this.tabTotalResults(response.TotalProductResults);
      }

      if (this.results().length <= 0) {
        this.hasNoResults(true);
      } else {
        this.hasNoResults(false);
      }
    }.bind(this)
  );
};

SearchComponent.prototype.constructSearchParams = function() {
  return {
    type: SEARCH_TYPES[this.currentFilter()],
    q: this.searchValue(),
    sort: SORT_TYPES[this.currentSort()],
    skip: this.skip(),
    take: TAKE
  };
};

SearchComponent.prototype.createHash = function(params) {
  // q (the search value) is required.
  if (!params || !params.q || params.q.length <= 0) {
    return;
  }

  var hash = '';
  if (params.q) {
    hash += '#q=' + encodeURIComponent(params.q);
  }
  if (params.type) {
    hash += '&type=' + encodeURIComponent(params.type);
  }
  if (params.sort) {
    hash += '&sort=' + encodeURIComponent(params.sort);
  }
  if (params.skip) {
    hash += '&skip=' + encodeURIComponent(params.skip);
  }

  window.location.hash = hash;
};

// Helper function.
SearchComponent.prototype.getSearchParameterFromHash = function(value, params) {
  var param = null;
  for (var i = params.length - 1; i >= 0; i--) {
    if (params[i].indexOf(value) !== -1) {
      param = params[i];
      // Remove the start that defines the variable, we only want the real value.
      // E.g. we don't want "#q=test", we only want "test".
      param = param.substring(value.length);
      break;
    }
  }
  return param;
};

SearchComponent.prototype.getParamsFromHash = function(hash) {
  var queryParams = hash.split('&'),
    search = this.getSearchParameterFromHash('#q=', queryParams),
    type = this.getSearchParameterFromHash('type=', queryParams),
    sort = this.getSearchParameterFromHash('sort=', queryParams),
    skip = this.getSearchParameterFromHash('skip=', queryParams);

  if (type) {
    this.currentFilter(SEARCH_TYPES.indexOf(type));
  }
  if (sort) {
    this.currentSort(SORT_TYPES.indexOf(sort));
  }
  if (skip) {
    this.skip(skip);
  }
  this.searchValue(decodeURIComponent(search));

  this.search();
};

SearchComponent.prototype.handleFilterClick = function(data, event) {
  // Get current target if it exists, else fetch srcElement (< IE 8).
  var target = event.currentTarget ? event.currentTarget : event.srcElement;
  // Update the filter.
  this.currentFilter($(target).data('filter-id'));
  this.search();
};
SearchComponent.prototype.handleSortClick = function(data, event) {
  // Get current target if it exists, else fetch srcElement (< IE 8).
  var target = event.currentTarget ? event.currentTarget : event.srcElement;
  // Update the filter.
  this.currentSort($(target).data('sort-id'));
  this.search();
};

SearchComponent.prototype.handleSearchInput = function() {
  this.search();
};

function SearchPage() {
  this.init();
}

SearchPage.prototype = new Base();
SearchPage.prototype.init = function() {
  var searchPage = $('[data-search-page]');
  if (searchPage.get(0) !== undefined) {
    ko.applyBindings(
      new SearchComponent({
        search: searchPage.data('search-page'),
        api: searchPage.data('search-api')
      }),
      searchPage.get(0)
    );
  }
};

module.exports = SearchPage;
